import styled from "styled-components"

export default {
    "Main": styled.main`
        display: flex;
        flex-grow: 1;
        background-color: ${({ theme }) => theme.color["white"]};
        padding-bottom: 62px;
    `
}